import axios from "axios";

/**
 * Service API pour la gestion des ajustements de points (Admin uniquement)
 */
export default {
  /**
   * Valide un ajustement de points avant de l'appliquer
   * @param {Object} adjustmentData - Données de l'ajustement
   * @param {number} adjustmentData.customerId - ID du client
   * @param {number} adjustmentData.amount - Montant de l'ajustement (positif = ajout, négatif = retrait)
   * @param {string} adjustmentData.reason - Raison de l'ajustement
   * @param {string} adjustmentData.franchiseGroup - Groupe de franchise
   * @param {string} adjustmentData.franchise - Franchise
   * @param {string} adjustmentData.subFranchise - Sous-franchise
   * @param {string} adjustmentData.sapg - SAPG
   * @param {string} adjustmentData.gimItemType - Type d'article GIM
   * @param {string} adjustmentData.gimBrand - Marque GIM
   * @param {string} adjustmentData.gimSubBrand - Sous-marque GIM
   * @param {string} adjustmentData.buyingGroupName - Nom du groupe d'achat
   * @param {string} adjustmentData.uom - Unité de mesure
   * @returns {Promise} Retourne la validation avec le solde actuel et le nouveau solde
   */
  validatePointAdjustment(adjustmentData) {
    return axios.post(
      "/api/statsContract/validatePointAdjustment",
      adjustmentData
    );
  },

  /**
   * Applique un ajustement de points après validation
   * @param {Object} adjustmentData - Données de l'ajustement (même structure que validatePointAdjustment)
   * @returns {Promise} Retourne un message de succès ou une erreur
   */
  updatePoints(adjustmentData) {
    return axios.post("/api/statsContract/updatePoints", adjustmentData);
  },

  /**
   * Récupère l'historique des ajustements de points
   * @param {number|null} customerId - ID du client (optionnel, pour filtrer par client)
   * @returns {Promise} Retourne la liste des ajustements
   */
  getPointAdjustmentHistory(customerId = null) {
    const url = customerId
      ? `/api/statsContract/pointAdjustmentHistory?customerId=${customerId}`
      : "/api/statsContract/pointAdjustmentHistory";
    return axios.get(url);
  },
};
